let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8lRQW")).then(() => parcelRequire('3f2BD'));